class ProductCard extends HTMLElement {
    static currentlyOpen = null;

    constructor() {
        super();
        this.productId = this.getAttribute("data-product-id");
        this.variantId = this.getAttribute("data-variant-id");
        this.productFormId = this.getAttribute("data-product-form-id");
        this._closeOnScroll = null;
        this._carouselContainer = null;

        // Setup listeners
        this.setupOpenBuyBuxButtonListener();
        this.setupCloseBuyBuxButtonListener();
        this.setupSubmitButtonListener();
    }

    // Listeners
    setupOpenBuyBuxButtonListener = () => {
        const openBuyBoxButton = document.querySelector(
            `[data-add][data-product-id="${this.productId}"]`,
        );
        if (!openBuyBoxButton) {
            return;
        }

        openBuyBoxButton.addEventListener("click", this.openBuyBoxCard);
        openBuyBoxButton.addEventListener(
            "mouseenter",
            this.setupSubscriptionCardContent,
        );
    };

    setupSubmitButtonListener = () => {
        const submitButton = this.querySelector('[type="submit"]');
        if (!submitButton) {
            return;
        }

        submitButton.addEventListener("click", this.addToCart);
    };

    setupCloseBuyBuxButtonListener = () => {
        const closeBuyBoxButton = this.querySelector(
            `a[data-close-${this.productId}]`,
        );
        if (!closeBuyBoxButton) {
            return;
        }

        closeBuyBoxButton.addEventListener("click", this.closeBuyBoxCard);
    };

    // BuyBox UI Functionality
    openBuyBoxCard = (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (ProductCard.currentlyOpen && ProductCard.currentlyOpen !== this) {
            ProductCard.currentlyOpen.closeBuyBoxCard();
        }

        const buyBoxOverlay = this.querySelector(
            ".product-card__buy-box-overlay",
        );
        if (!buyBoxOverlay) {
            return;
        }

        const isMobile = window.innerWidth <= 480;

        if (isMobile) {
            buyBoxOverlay.style.position = "fixed";
            buyBoxOverlay.style.top = "0";
            buyBoxOverlay.style.left = "0";
            buyBoxOverlay.style.width = "100%";
            buyBoxOverlay.style.height = "100%";
            buyBoxOverlay.style.zIndex = "1000";
        } else {
            const rect = this.getBoundingClientRect();
            buyBoxOverlay.style.position = "fixed";
            buyBoxOverlay.style.top = `${rect.top}px`;
            buyBoxOverlay.style.left = `${rect.left}px`;
            buyBoxOverlay.style.width = `${rect.width}px`;
            buyBoxOverlay.style.height = `${rect.height}px`;
            buyBoxOverlay.style.zIndex = "1000";

            this._closeOnScroll = () => this.closeBuyBoxCard();
            window.addEventListener("scroll", this._closeOnScroll, { once: true });
            this._carouselContainer = this.closest(".rbsv4-product-carousel__carousel");
            if (this._carouselContainer) {
                this._carouselContainer.addEventListener("scroll", this._closeOnScroll, { once: true });
            }
        }

        buyBoxOverlay.style.setProperty("display", "block");
        ProductCard.currentlyOpen = this;
    };

    closeBuyBoxCard = (e) => {
        e?.stopPropagation();
        e?.preventDefault();

        const buyBoxOverlay = this.querySelector(
            ".product-card__buy-box-overlay",
        );
        if (!buyBoxOverlay) {
            return;
        }

        buyBoxOverlay.style.setProperty("display", "none");
        buyBoxOverlay.style.position = "";
        buyBoxOverlay.style.top = "";
        buyBoxOverlay.style.left = "";
        buyBoxOverlay.style.width = "";
        buyBoxOverlay.style.height = "";
        buyBoxOverlay.style.zIndex = "";

        if (ProductCard.currentlyOpen === this) {
            ProductCard.currentlyOpen = null;
        }

        if (this._closeOnScroll) {
            window.removeEventListener("scroll", this._closeOnScroll);
            if (this._carouselContainer) {
                this._carouselContainer.removeEventListener("scroll", this._closeOnScroll);
                this._carouselContainer = null;
            }
            this._closeOnScroll = null;
        }
    };

    // SubscriptionContent UI Functionality
    setupSubscriptionCardContent = () => {
        this.addSubscriptionBenefitsSection();
        this.addSubscriptionNotesSection();
    };

    addSubscriptionBenefitsSection = () => {
        const BENEFITS_HTML = `
        <ul>
            <li>
                <span class="seal-subscription-benefits-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="74" height="59" viewBox="0 0 74 59" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M50.3436 58.8965V31.56L74 17.9019V44.1919C74 44.8559 73.6684 45.4299 73.0935 45.7619L50.3436 58.8965ZM21.8867 45.31H2.79957C1.25352 45.31 0 44.0564 0 42.5104C0 40.9643 1.25352 39.7108 2.79957 39.7108H21.7871C25.0702 39.7108 25.0702 34.4675 21.7871 34.4675H10.3769C8.83086 34.4675 7.5772 33.214 7.5772 31.668C7.5772 30.1219 8.83086 28.8684 10.3769 28.8684H19.3011C22.5843 28.8684 22.5843 23.6251 19.3011 23.6251H2.79971C1.25366 23.6251 0.000144531 22.3716 0.000144531 20.8255C0.000144531 19.2795 1.25366 18.0259 2.79971 18.0259H21.9773L45.4195 31.5604V58.8965L21.8867 45.31ZM24.2074 13.642L47.8815 27.3102L71.5555 13.6419L47.9268 0H32.4239C30.8778 0 29.6243 1.25352 29.6243 2.79957C29.6243 4.34562 30.8778 5.59914 32.4239 5.59914H35.7001C36.001 5.59914 36.2532 5.79267 36.3311 6.08332C36.4089 6.37397 36.2873 6.66766 36.0267 6.81826L24.2074 13.642ZM22.8598 0C24.4058 0 25.6594 1.25352 25.6594 2.79957C25.6594 4.34562 24.4058 5.59914 22.8598 5.59914H5.84311C4.29706 5.59914 3.04339 4.34562 3.04339 2.79957C3.04339 1.25352 4.29691 0 5.84311 0H22.8598Z" fill="black"/></svg></span>FREE shipping on every US order over $45!</li><li><span class="seal-subscription-benefits-icon"><svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none"><path d="M24.7507 4.24923C19.0855 -1.41601 9.91529 -1.41681 4.24925 4.24923C-1.41599 9.91447 -1.41684 19.0847 4.24925 24.7507C9.91449 30.416 19.0847 30.4168 24.7507 24.7507C30.4159 19.0855 30.4168 9.91532 24.7507 4.24923ZM13.2714 18.7337C13.2714 19.3913 12.7383 19.9244 12.0807 19.9244C11.423 19.9244 10.8899 19.3913 10.8899 18.7337V10.2663C10.8899 9.60862 11.423 9.07551 12.0807 9.07551C12.7383 9.07551 13.2714 9.60862 13.2714 10.2663V18.7337ZM18.1099 18.7337C18.1099 19.3913 17.5768 19.9244 16.9192 19.9244C16.2616 19.9244 15.7285 19.3913 15.7285 18.7337V10.2663C15.7285 9.60862 16.2616 9.07551 16.9192 9.07551C17.5768 9.07551 18.1099 9.60862 18.1099 10.2663V18.7337Z" fill="black"/></svg></span>Cancel, skip or change frequency anytime!</li><li><span class="seal-subscription-benefits-icon"><svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.6815 0.318713C16.7376 0.130142 16.9114 0 17.1085 0C17.3057 0 17.4795 0.130142 17.5356 0.318713C17.5356 0.318713 18.3172 2.93857 19.1549 5.74856C20.4897 10.2254 23.9917 13.7274 28.4685 15.0622C31.2785 15.8999 33.8984 16.6815 33.8984 16.6815C34.0869 16.7376 34.2171 16.9114 34.2171 17.1086C34.2171 17.3057 34.0869 17.4795 33.8984 17.5356C33.8984 17.5356 31.2785 18.3172 28.4685 19.1549C23.9917 20.4897 20.4897 23.9917 19.1549 28.4685C18.3172 31.2785 17.5356 33.8984 17.5356 33.8984C17.4795 34.087 17.3057 34.2171 17.1085 34.2171C16.9114 34.2171 16.7376 34.087 16.6815 33.8984C16.6815 33.8984 15.8999 31.2785 15.0622 28.4685C13.7274 23.9917 10.2254 20.4897 5.74855 19.1549C2.93857 18.3172 0.318713 17.5356 0.318713 17.5356C0.13013 17.4795 0 17.3057 0 17.1086C0 16.9114 0.13013 16.7376 0.318713 16.6815C0.318713 16.6815 2.93857 15.8999 5.74855 15.0622C10.2254 13.7274 13.7274 10.2254 15.0622 5.74856C15.8999 2.93857 16.6815 0.318713 16.6815 0.318713Z" fill="black"/>
                    </svg>
                </span>
                Guaranteed lowest price!
            </li>
        </ul>`;

        const subscriptionContainer = this.querySelector(
            `[data-subscription-${this.productId}]`,
        );
        if (!subscriptionContainer) {
            return;
        }

        const subscriptionCardContainer = subscriptionContainer.querySelector(
            ".sls-option-container.seal-table[data-selling-plan-group]",
        );
        if (!subscriptionCardContainer) {
            return;
        }

        const labelContainer = subscriptionCardContainer.querySelector(
            ".sls-label-container.seal-col",
        );
        if (!labelContainer) {
            return;
        }

        const firstLine = labelContainer.querySelector(
            ".sls-selling-plan-group-first-line",
        );
        let existingBenefits = labelContainer.querySelector(
            ".seal-subscription-benefits",
        );
        if (!existingBenefits) {
            const benefitsDiv = document.createElement("div");
            benefitsDiv.className = "seal-subscription-benefits";
            benefitsDiv.innerHTML = BENEFITS_HTML;
            firstLine.parentNode.insertBefore(
                benefitsDiv,
                firstLine.nextSibling,
            );
            existingBenefits = benefitsDiv;
        }
    };

    addSubscriptionNotesSection = () => {
        const NOTES_HTML =
            '<span class="seal-subscription-notes-title">Frequency of Deliveries:</span><span class="seal-subscription-notes-info">(Subscriptions require purchasing with Shop Pay)</span>';

        const subscriptionContainer = this.querySelector(
            `[data-subscription-${this.productId}]`,
        );
        if (!subscriptionContainer) {
            return;
        }

        const subscriptionCardContainer = subscriptionContainer.querySelector(
            ".sls-option-container.seal-table[data-selling-plan-group]",
        );
        if (!subscriptionCardContainer) {
            return;
        }

        const labelContainer = subscriptionCardContainer.querySelector(
            ".sls-label-container.seal-col",
        );
        if (!labelContainer) {
            return;
        }

        const existingBenefits = labelContainer.querySelector(
            ".seal-subscription-benefits",
        );
        const existingNotes = labelContainer.querySelector(
            ".seal-subscription-notes",
        );

        if (!existingNotes) {
            const notesDiv = document.createElement("div");
            notesDiv.className = "seal-subscription-notes";
            notesDiv.innerHTML = NOTES_HTML;
            existingBenefits.parentNode.insertBefore(
                notesDiv,
                existingBenefits.nextSibling,
            );
        }
    };

    // ATC Functionality
    addToCart = async (e) => {
        e.stopPropagation();
        e.preventDefault();

        try {
            const addToCartForm = this.querySelector(
                `form[action$="/cart/add"][id="${this.productFormId}"]`,
            );
            const rawFormData = new FormData(addToCartForm);
            let formData = {};

            // create formData properties
            for (const [key, value] of rawFormData) {
                const match = key.match(/properties\[(.+?)\]/);
                if (match) {
                    if (formData["properties"] === undefined) {
                        formData["properties"] = {};
                    }

                    const propertyKey = match?.[1];
                    formData["properties"][propertyKey] = value;
                } else {
                    formData[key] = value;
                }
            }

            const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                document.dispatchEvent(new CustomEvent("cart:refresh"));
                this.closeBuyBoxCard();
            } else {
                throw new Error("Failed to add to cart");
            }
        } catch (error) {}
    };
}

customElements.define("product-card", ProductCard);
